import React from 'react';

import socialHttp from '../../../../vendor/z5internet/react-social/src/resources/assets/js/src/utils/socialHttp';

import throttle from 'lodash/throttle';

class RecordFeedActivity extends React.Component {
	constructor(props, context) {
		super(props, context);

		this.startPos = {}; // 0 above 1 below

		this.timeInView = {};
		this.seen = {};
	}

	componentDidMount() {
		window.addEventListener('scroll', throttle(this.handleScroll, 500));
		window.addEventListener('resize', throttle(this.handleScroll, 500));

		document.addEventListener(
			'react_social_click_on_post_link',
			this.handleClickOnLink
		);
		document.addEventListener(
			'react_social_click_on_see_more',
			this.handleClickOnSeeMore
		);
		document.addEventListener(
			'react_social_click_on_show_more_comments',
			this.handleClickOnShowMoreComments
		);
		document.addEventListener(
			'react_social_click_on_show_more_posts',
			this.handleClickOnShowMorePosts
		);
		document.addEventListener('react_social_play_video', this.handlePlayVideo);

		document.addEventListener('react_social_view_image', this.handleViewImage);
		document.addEventListener(
			'react_social_view_profile',
			this.handleViewOnProfile
		);
	}

	handleClickOnLink = (e) => {
		const pid = e.detail.pid;
		const post = e.detail.post;
		const url = e.detail.url;

		this.sendEvent(pid, 'post_link_click', { url });
	};

	handleClickOnSeeMore = (e) => {
		const pid = e.detail.pid;

		this.sendEvent(pid, 'clickSeeMore', {});
	};

	handleClickOnShowMoreComments = (e) => {
		const pid = e.detail.pid;

		this.sendEvent(pid, 'clickShowMoreComments', {});
	};

	handleClickOnShowMorePosts = (e) => {
		const pid = e.detail.pid;

		this.sendEvent(pid, 'clickShowMorePosts', {});
	};

	handlePlayVideo = (e) => {
		const notes = e.detail;
		const pid = notes.pid;
		delete notes.pid;

		this.sendEvent(pid, 'playVideo', notes);
	};

	handleViewImage = (e) => {
		const i = e.detail.i;
		const pid = e.detail.pid;

		this.sendEvent(pid, 'viewImage', { i });
	};

	handleViewOnProfile = (e) => {
		const obj = e.detail.obj;

		this.sendEvent(obj, 'profile_view', {});

		this.handleScroll();
	};

	handleScroll = () => {
		const items = Array.from(document.querySelectorAll('[data-pid]'));

		for (var i = 0; i < items.length; i++) {
			const item = items[i];

			this.hasItemBeenViewed(item);
		}
	};

	hasItemBeenViewed = (el) => {
		if (window.location.pathname.match(/earnCredits/)) {
			return;
		}

		if (el.clientHeight == 0) {
			return;
		}

		const pid = el.dataset.pid;

		const scroll = window.scrollY || window.pageYOffset;
		const boundsTop = el.getBoundingClientRect().top + scroll;

		if (!this.seen[pid]) {
			this.seen[pid] = 0;
		}

		if (!this.timeInView[pid]) {
			this.timeInView[pid] = false;
		}

		if (this.startPos[pid] === undefined) {
			this.startPos[pid] = 1;
		}

		const tv = scroll;

		const bv = scroll + window.innerHeight;

		const ti = boundsTop;

		const bi = boundsTop + el.clientHeight;

		const posti = (function () {
			if (ti <= tv) {
				return 0;
			}

			if (tv < ti && ti < bv) {
				return 1;
			}

			if (bv <= ti) {
				return 2;
			}
		})();

		const posbi = (function () {
			if (bi <= tv) {
				return 0;
			}

			if (tv < bi && bi < bv) {
				return 1;
			}

			if (bv <= bi) {
				return 2;
			}
		})();

		let seen = 0;

		let iv;
		let outOfView = false;

		if (posti == 0 && posbi == 0) {
			iv = 0;
			outOfView = true;
		}

		if (posti == 2 && posbi == 2) {
			iv = 1;
			outOfView = true;
		}

		// post is still out of view
		// OR post started from 1 position and went out of view same side
		// OR post has been seen and is now out of view

		if (iv === this.startPos[pid] || (this.seen[pid] == 10 && outOfView)) {
			this.seen[pid] = 0;
			this.startPos[pid] = iv;
			this.timeInView[pid] = false;

			return;
		}

		switch (this.startPos[pid]) {
			case 0:
				if (posbi == 1 || posbi == 2) {
					seen = 5;

					if (posti == 1 || posti == 2) {
						seen = 10;
					}

					if (posti == 2) {
						this.startPos[pid] = 1;
					}
				}

				break;
			case 1:
				if (posti == 0 || posti == 1) {
					seen = 5;

					if (posbi == 0 || posbi == 1) {
						seen = 10;
					}
				}

				if (posbi == 0) {
					this.startPos[pid] = 0;
				}

				break;
		}

		if (!seen) {
			this.seen[pid] = 0;
			return;
		}

		if (seen != this.seen[pid] && this.seen[pid] < 10) {
			if (this.seen[pid] == 0) {
				this.timeInView[pid] = new Date().getTime();
				this.seen[pid] = 5;
			}

			if (seen == 10) {
				if (
					!this.timeInView[pid] ||
					new Date().getTime() - this.timeInView[pid] < 2000
				) {
					if (outOfView) {
						this.seen[pid] = 0;
						this.timeInView[pid] = false;
					}

					return;
				}
			}

			this.seen[pid] = seen;

			this.sendEvent(pid, 'post_view', {
				seen,
				time: seen == 10 && new Date().getTime() - this.timeInView[pid],
			});
		}
	};

	sendEvent(obj, type, notes) {
		notes.source = 'website';

		socialHttp('post', '/data/feed/recordFeedActivity/' + type, {
			notes,
			obj,
		});
	}

	render() {
		return null;
	}
}

export default RecordFeedActivity;
